import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { filter, iif, map, of, take, withLatestFrom } from 'rxjs';
import { University } from '../../shared/models/entities/university.entity';
import { Semester } from '../../shared/models/entities/semester.entity';
import { Store } from '@ngrx/store';
import * as GlobalEntitiesSelectors from '../state/global-entities-state/global-entities.selectors';
import * as AuthSelectors from '../state/auth-state/auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class AppTypeService {
  constructor(private store: Store) {}

  get isDefault() {
    return environment.app_type === 'default';
  }

  get isPass() {
    return environment.app_type === 'pass';
  }

  get currentPassWriterUniversityAndSemester$() {
    return iif(
      () => this.isDefault,
      of([undefined, undefined, undefined] as [University[], University, Semester]),
      this.store.select(GlobalEntitiesSelectors.universities).pipe(
        filter((universities) => !!universities),
        take(1),
        withLatestFrom(
          this.store.select(AuthSelectors.currentPassWriterUniversity),
          this.store.select(AuthSelectors.currentPassWriterSemester)
        )
      )
    ).pipe(
      map(([universities, currentPassWriterUniversity, currentPassWriterSemester]) => {
        return [currentPassWriterUniversity, currentPassWriterSemester] as [University, Semester];
      })
    );
  }
}
